import { AST } from '@handlebars/parser';
import { serializeHandlebar } from 'modules/handlebars/utils/serializeHandlebar';
import { concatenate, joinWithSpaces } from 'utils/stringHelpers';
import { ExpressionSerializer } from '../../expression/serializer';
import { BLOCK_CLOSE_PREFIX, PARTIAL_BLOCK_PATH_PREFIX } from '../constants';
import { StatementListSerializerFn } from '../types';
import { StatementArgsSerializer } from './args';

export class PartialBlockStatementSerializer {
  static serialize = (
    statement: AST.PartialBlockStatement,
    serializeAll: StatementListSerializerFn,
  ) => {
    const body = serializeAll(statement.program.body);
    const openingTag =
      PartialBlockStatementSerializer.serializePartialBlockStatementOpenTag(statement);
    const closingTag =
      PartialBlockStatementSerializer.serializePartialBlockStatementCloseTag(statement);
    return concatenate([openingTag, body, closingTag]);
  };

  private static serializePartialBlockStatementOpenTag = (statement: AST.PartialBlockStatement) => {
    const nameAndPrefix = concatenate([
      PARTIAL_BLOCK_PATH_PREFIX,
      ExpressionSerializer.serialize(statement.name),
    ]);
    return serializeHandlebar(
      joinWithSpaces([nameAndPrefix, StatementArgsSerializer.serialize(statement)]),
      statement.openStrip,
    );
  };

  private static serializePartialBlockStatementCloseTag = (
    statement: AST.PartialBlockStatement,
  ) => {
    const name = ExpressionSerializer.serialize(statement.name);
    return serializeHandlebar(concatenate([BLOCK_CLOSE_PREFIX, name]), statement.closeStrip);
  };
}
